import { AxiosPromise, AxiosError } from '@libs/http';
import {
  useMutation as mutation,
  UseMutationOptions,
} from '@tanstack/vue-query';

export type UseMutationConfig<T> = UseMutationOptions<
  AxiosPromise<T>,
  AxiosError,
  any | Record<string, any>,
  any[]
> & {
  key?: any[];
  onReject?: (...arg: any[]) => void;
  onSettled?: (...arg: any[]) => void;
  onSuccess?: (...arg: any[]) => void;
};

export function useMutation<T>(
  fetcher: (...arg: any[]) => AxiosPromise<T>,
  {
    key = [],
    cacheTime = 1000 * 60 * 60, // 1h

    onReject = () => {},
    onSuccess = () => {},
    onSettled = () => {},
  }: UseMutationConfig<T>
) {
  const {
    data,
    isError,
    isLoading,
    isSuccess,
    mutate,
    isIdle,
    status,
    ...query
  } = mutation({
    mutationFn: fetcher,
    mutationKey: key,
    cacheTime,
    onSuccess,
    onError: onReject,
    onMutate: onSettled,
  });

  return {
    execute: mutate,

    isIdle,
    // 'isPending' is specified more than once, so this usage will be overwritten. (by ...query below)
    // so for now we just comment it out. check it out later.
    // isPending: isLoading,
    isError,
    isSuccess,

    result: data,
    ...query,
  };
}
